export default {
    data() {
        return {
            blogs: [], //渲染的随笔
            allBlogs: [], //全部随笔
            current: 1,//当前页
            navBar: [],
            navIdx: 0,
            allDatas: {},//所有种类随笔
        }
    },
    created() {
        this.initData();
    },
    methods: {
        //获取经典随笔
        async initData() {
            const { API, $request } = this;
            const url = API.getBlogList;
            const { data: res } = await $request(url, 'get', {
                blogType: '1',
                blogStatus: '1',
            })
            const blogs = res.data || [];
            const obj = {};
            const set = new Set();
            for (const blog of blogs) {
                for (const p of blog.parent) {
                    if (obj[p.name]) {
                        obj[p.name].push(blog);
                    } else {
                        obj[p.name] = [blog];
                    }
                    set.add(p.name);
                }
            }
            this.allDatas = obj;
            this.navBar = [...set]; //导航栏
            const list = obj[this.navBar[0]] || [];
            this.allBlogs = list;
            this.blogs = list.slice(0, 10);
        },

        //加载更多
        loadmore() {
            if (this.blogs.length >= this.allBlogs.length) return;
            this.current++;
            const start = (this.current - 1) * 10;
            const end = start + 10;

            const list = this.allBlogs.slice(start, end);
            this.blogs = this.blogs.concat([...list]);
        },

        //切换导航栏
        changeNav(index) {
            this.navIdx = index;
            this.current = 1;
            const list = this.allDatas[this.navBar[index]] || [];
            this.allBlogs = list;
            this.blogs = list.slice(0, 10);
        }
    }
}